import { apiRequest } from './queryClient';
import type {
  AgenticRolloutAuditLogRow,
  AgenticRolloutOverrideRow,
  AgenticRolloutSettingsRow,
} from '@shared/schema';

export interface RolloutStatusResponse {
  flagEnabled: boolean;
  settings: AgenticRolloutSettingsRow;
  overrides: AgenticRolloutOverrideRow[];
}

export const fetchRolloutStatus = async () => {
  return await apiRequest<RolloutStatusResponse>(
    'GET',
    '/api/admin/orchestration/rollout',
  );
};

export const updateRolloutSettings = async (
  payload: Partial<{
    rolloutStage: AgenticRolloutSettingsRow['rolloutStage'];
    rolloutPercentage: number;
    stickinessTtlMs: number;
    killSwitch: boolean;
    defaultCohort?: string;
    decisionSalt?: string;
  }>,
) => {
  return await apiRequest<AgenticRolloutSettingsRow>(
    'PATCH',
    '/api/admin/orchestration/rollout/settings',
    payload,
  );
};

export const upsertRolloutOverride = async (payload: {
  userId: number;
  mode: 'force_v1' | 'force_v2';
  cohort?: string;
  reason?: string;
  expiresAt?: string | null;
}) => {
  return await apiRequest<AgenticRolloutOverrideRow>(
    'POST',
    '/api/admin/orchestration/rollout/overrides',
    payload,
  );
};

export const deleteRolloutOverride = async (userId: number) => {
  return await apiRequest<{ success: boolean }>(
    'DELETE',
    `/api/admin/orchestration/rollout/overrides/${userId}`,
  );
};

export const fetchRolloutAudit = async (limit = 50) => {
  const query = new URLSearchParams();
  query.set('limit', String(limit));
  return await apiRequest<AgenticRolloutAuditLogRow[]>(
    'GET',
    `/api/admin/orchestration/rollout/audit?${query.toString()}`,
  );
};
